import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import Swal from 'sweetalert2';
import { API_URL } from '../../Constants';
import TextField from '@mui/material/TextField';


let apiUrl = API_URL;


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});


export default function CreditsToApprove() {

    const [data, setData] = useState([]);

    const handleApproveCredit = (creditUuid) => {

        Swal.fire({
            title: '¿Desea aprobar este crédito? ',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#161e55',
            cancelButtonColor: '#387A9C',
            confirmButtonText: 'Aprobar',
            denyButtonText: `Don't save`
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.fire('Credito Aprobado!', '', 'success')
                let fechaReal = "fecha-" + creditUuid
                let creditDateObtained = document.getElementById(fechaReal).value + 'T10:00:00';
                console.log(creditDateObtained);
                let creditRequest = { status: "APPROVED", paymentStartDate: creditDateObtained }
                fetch(apiUrl + '/v1/credits/' + creditUuid + '/credit-response', {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json ',
                        'Accept': 'application/json',
                    },
                    body: JSON.stringify(creditRequest),
                }).then(function (response) {
                    if (response.ok) {
                        response.json().then(function (res) {
                            console.log(res.uuid)
                            window.location = '/credits-to-review';
                        });
                    }
                }).catch(function (error) {
                    console.log('Hubo un problema con la petición Fetch:' + error.message);
                });
            }
        });
    }

    useEffect(() => {
        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }
        fetch(apiUrl + '/v1/credits/commerce-approve-documents/', {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    console.log(res);
                    setData(res);
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });



    }, []);

    var formatter = new Intl.NumberFormat('es-US', {
        style: 'currency',
        currency: 'COP',
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    const handleBackToHome = () => {
        window.location = '/general-admin';
    }

    const handleGetImage = (imageUuid) => {
        fetch(apiUrl + '/v1/images/' + imageUuid, {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    verImagen(res.uuid + "." + res.ext);
                })
            } else {
                alert("Image Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
    }

    const verImagen = (imageName) => {
        fetch(apiUrl + '/v1/s3/url/' + imageName, {
            method: 'GET'
        }).then(function (response) {
            if (response.ok) {
                response.json().then(res => {
                    window.location = res
                })
            } else {
                alert("CommerceUuid Not Found");
            }
        }).catch(function (error) {
            console.log("Bad petition:" + error.message);
        });
    }
    return (
        <React.Fragment>
            <Header name={"admin"} />
            <Container maxWidth="xl">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={10}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Comercio</TableCell>
                                            <TableCell align="center">Nombre</TableCell>
                                            <TableCell align="center">Valor Crédito</TableCell>
                                            <TableCell align="center">Valor Cuota</TableCell>
                                            <TableCell align="center">Tasa</TableCell>
                                            <TableCell align="center">Fecha de Creación</TableCell>
                                            <TableCell align="center">Factura</TableCell>
                                            <TableCell align="center">Pagaré</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data.map((row) => (
                                            <TableRow key={row.client.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center">{row.commerce.companyName} </TableCell>
                                                <TableCell align="center">{row.client.name} {row.client.lastName}</TableCell>
                                                <TableCell align="center">{formatter.format(row.totalValue)}</TableCell>
                                                <TableCell align="center">{formatter.format(row.quotaValue)}</TableCell>
                                                <TableCell align="center">{row.interestRate}%</TableCell>
                                                <TableCell align="center"> <TextField id={"fecha-" + row.uuid} label="yyyy-mm-dd" variant="outlined" /></TableCell>
                                                <TableCell align="center"><Button variant="text" onClick={() => handleGetImage(row.invoiceUuid)}>Ver</Button></TableCell>
                                                <TableCell align="center"><Button variant="text" onClick={() => handleGetImage(row.promissoryNoteUuid)}>Ver</Button></TableCell>
                                                <TableCell align="center">< ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={() => handleApproveCredit(row.uuid)}>Aprobar</ButtonPrincipal></TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <br />
                            <br />
                            <ButtonPrincipal variant="contained" endIcon={<SendIcon />} onClick={handleBackToHome}>
                                Volver
                            </ButtonPrincipal>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}